import React from "react";

const NavBtn = React.memo(function NavBtn({ label, disabled, onClick }) {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`flex items-center gap-2 px-4 py-2 border border-paper-deep rounded font-serif text-[13px] tracking-wide transition-all duration-150
                ${disabled
                    ? 'text-ink-faint/30 cursor-not-allowed border-paper-deep/50'
                    : 'text-ink-faint hover:border-gold hover:text-gold hover:bg-gold/5'
                }`}
            aria-label={label}
        >
            {label}
        </button>
    );
});

export default NavBtn;
